<script>
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js";
import {computed, ref, watch} from "vue";
import {useWorkerStore} from "@/stores/Worker/Worker.js";
import AdvancedWorkerFilter from "@/views/Worker/Components/WorkerFilter.vue";
import {storeToRefs} from "pinia";
import WorkerImage from "@/views/Worker/Components/WorkerImage.vue";
import axios from "axios";

export default {
    props: {
        intranet: {
            type: Boolean,
            default: false
        },
    },
    components: {
        WorkerImage,
        AdvancedWorkerFilter,
    },
    setup(props) {
        const {loading, total,} = useSharedData();
        
        const {getBack, transformFilterValues, formatedDate} = useSharedMethod();
        
        const {$router, $i18n} = useTools();
        
        const workerStore = useWorkerStore();
        const securityStore = useSecurityStore();
        const {idControlProgram, idIssue, selectedModule} = storeToRefs(securityStore);
        
        const rootPath = computed(() => props.intranet ? 'intranet_workers' : 'workers');
        
        const filter = ref({
            phase: "ACTIVE",
            programIds: idControlProgram.value && selectedModule.value && selectedModule.value === 'worker' ? [idControlProgram.value] : []
        });
        
        const headers = ref([
            {
                text: "...",
                align: "start",
                sortable: false,
                value: "action",
            },
        ]);
        
        const imageHeader = {
            text: "",
            align: "start",
            sortable: false,
            value: "photo",
            fixed: true,
        };
        
        if (securityStore.userContext.workerShowImage)
            headers.value.push(imageHeader);
        
        const rawHeaders = [
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "code",
                fixed: true,
                displayId: "[#MATRICULE#]",
            },
            {
                text: $i18n.t("common.lastname"),
                align: "start",
                sortable: true,
                value: "lastName",
                fixed: true,
                displayId: "[#NOM#]",
            },
            {
                text: $i18n.t("common.firstname"),
                align: "start",
                sortable: true,
                value: "firstName",
                displayId: "[#PRENOM#]",
            },
            {
                text: $i18n.t("module.occupation"),
                align: "start",
                sortable: true,
                value: "occupationName",
                displayId: "[#FONCTION#]",
            },
            {
                text: $i18n.t("module.organizational_chart"),
                align: "start",
                sortable: true,
                value: "organizationalChartName",
                displayId: "[#ORGANIGRAMME#]",
            },
            {
                text: $i18n.t("common.enter_date"),
                align: "start",
                sortable: true,
                value: "realEnterDate",
                displayId: "[#DATE DE RECRUTEMENT#]",
            },
            {
                text: $i18n.t("common.grille"),
                align: "start",
                sortable: true,
                value: "occupationCategoryClasseName",
                displayId: "[#GRILLE#]",
            },
            {
                text: $i18n.t("module.state"),
                align: "start",
                sortable: true,
                value: "stateName",
                displayId: "[#ETAT EMPLOYE#]",
            },
            {
                text: $i18n.t("worker.phase"),
                align: "start",
                sortable: true,
                value: "phase",
                displayId: "[#STATUT#]",
            },
            {
                text: $i18n.t("common.birth_day"),
                align: "start",
                sortable: true,
                value: "birthDay",
                displayId: "[#DATE NAISSANCE#]",
            },
            {
                text: $i18n.t("common.birth_place"),
                align: "start",
                sortable: true,
                value: "birthPlace",
                displayId: "[#LIEU NAISSANCE#]",
            },
            {
                text: $i18n.t("common.sex"),
                align: "start",
                sortable: true,
                value: "sex",
                displayId: "[#SEXE#]",
            },
            {
                text: $i18n.t("data_select.WORKER_FAMILY_SITUATION"),
                align: "start",
                sortable: true,
                value: "familySituationName",
                displayId: "[#SITUATION FAMILIALE#]",
            },
            {
                text: $i18n.t("worker.wedding_date"),
                align: "start",
                sortable: true,
                value: "weddingDate",
                displayId: "[#DATE MARIAGE#]",
            },
            {
                text: $i18n.t("common.address"),
                align: "start",
                sortable: true,
                value: "address",
                displayId: "[#ADRESSE#]",
            },
            {
                text: $i18n.t("worker.personal_phone"),
                align: "start",
                sortable: true,
                value: "personalPhone",
                displayId: "[#TÉLÉPHONE PERSONNEL#]",
            },
            {
                text: $i18n.t("worker.professional_phone"),
                align: "start",
                sortable: true,
                value: "professionalPhone",
                displayId: "[#TÉLÉPHONE PROFESSIONNEL#]",
            },
            {
                text: $i18n.t("common.email"),
                align: "start",
                sortable: true,
                value: "email",
                displayId: "[#EMAIL#]",
            },
            {
                text: $i18n.t("data_select.SOCIO_PROFESSIONAL"),
                align: "start",
                sortable: true,
                value: "occupationSocioProfessionalName",
                displayId: "[#SOCIO PROFESSIONNELLE#]",
            },
            {
                text: $i18n.t("worker.responsible"),
                align: "start",
                sortable: true,
                value: "responsibleName",
                displayId: "[#RESPONSABLE HIERARCHIQUE#]",
            },
            {
                text: $i18n.t("data_select.WORKER_COMPANY"),
                align: "start",
                sortable: true,
                value: "companyName",
                displayId: "[#SOCIETE DE DECLARATION#]",
            },
            {
                text: $i18n.t("data_select.WORKER_WORKPLACE"),
                align: "start",
                sortable: true,
                value: "workplaceName",
                displayId: "[#LIEUX DE TRAVAIL#]",
            },
            {
                text: $i18n.t("common.exit_date"),
                align: "start",
                sortable: true,
                value: "exitDate",
                displayId: "[#DATE SORTIE#]",
            },
            {
                text: $i18n.t("data_select.WORKER_EXIT_REASON"),
                align: "start",
                sortable: true,
                value: "leavingCauseName",
                displayId: "[#MOTIF DE SORTIE#]",
            },
            {
                text: $i18n.t("worker.nss"),
                align: "start",
                sortable: true,
                value: "nss",
                displayId: "[#NUMERO SECURITE SOCIALE#]",
            },
            {
                text: $i18n.t(""),
                align: "start",
                sortable: true,
                value: "numMutuelle",
                displayId: "[#NUMERO MUTUELLE#]",
            },
            {
                text: $i18n.t("worker.mutuelle_number"),
                align: "start",
                sortable: true,
                value: "carteShifaNumber",
                displayId: "[#NUMERO CARTE SHIFA#]",
            },
            {
                text: $i18n.t("worker.bank_account_number"),
                align: "start",
                sortable: true,
                value: "numCompte",
                displayId: "[#NUMERO COMPTE BANQUAIRE#]",
            },
            {
                text: $i18n.t("CCP"),
                align: "start",
                sortable: true,
                value: "numCcp",
                displayId: "[#NUMERO CCP#]",
            },
            {
                text: $i18n.t("worker.father_first_name"),
                align: "start",
                sortable: true,
                value: "prenomPere",
                displayId: "[#PRÉNOM PÈRE#]",
            },
            {
                text: $i18n.t("worker.father_birth_day"),
                align: "start",
                sortable: true,
                value: "dateNaissancePere",
                displayId: "[#DATE NAISSANCE PÈRE#]",
            },
            {
                text: $i18n.t("worker.mother_last_name"),
                align: "start",
                sortable: true,
                value: "nomMere",
                displayId: "[#NOM MÈRE#]",
            },
            {
                text: $i18n.t("worker.mother_first_name"),
                align: "start",
                sortable: true,
                value: "prenomMere",
                displayId: "[#PRENOM MÈRE#]",
            },
            {
                text: $i18n.t("worker.mother_birth_day"),
                align: "start",
                sortable: true,
                value: "dateNaissanceMere",
                displayId: "[#DATE NAISSANCE MÈRE#]",
            },
            {
                text: $i18n.t("module.cnas_agency"),
                align: "start",
                sortable: true,
                value: "cnasAgencyName",
                displayId: "[#AGENCE CNAS#]",
            },
        ];
        
        const defaultFields = props.intranet
            ? securityStore.userContext.intranetDefaultWorkerListingFields
            : securityStore.userContext.defaultWorkerListingFields;
        
        // Map each ID to its position in the order array for fast lookups
        const positionMap = new Map(defaultFields.map((id, index) => [id, index]));
        
        const result = rawHeaders
            .filter(item => positionMap.has(item.displayId))
            .sort((a, b) => positionMap.get(a.displayId) - positionMap.get(b.displayId))
        
        headers.value.push(...result);
        
        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: (item) => item.updateOption,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.edit`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: (item) => item.deleteOption,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.delete`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.deactivate"),
                icon: 'mdi-power-plug-off',
                color: 'grey',
                access: (item) => item.updateOption,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.deactivate`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t('worker.print_ats'),
                icon: 'mdi-file',
                color: 'blue darken-2',
                access: (item) => item.printOption,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.ats`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("module.edms"),
                icon: 'mdi-folder',
                color: 'amber',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.documents`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("module.template_application"),
                icon: 'mdi-text-box-multiple',
                color: 'teal',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.template_applications`, params: {id: item.id}})
                },
            },
        ];
        
        const searchParams = ref({
            sortBy: "lastName",
            descending: false,
            page: 1,
            itemsPerPage: securityStore.userContext.workerRowsPerPage
        });
        
        function handleSearch(params) {
            loading.value = true;
            workerStore.setWorkers([]);
            total.value = 0;
            
            filter.value.calculateRung = false;
            filter.value.calculateIep = false;
            
            filter.value.page = params.page - 1;
            filter.value.rowsPerPage = params.itemsPerPage;
            filter.value.sortBy = params.sortBy;
            filter.value.descending = params.descending;
            
            axios.get('/workers', {params: transformFilterValues(filter.value)}).then((response) => {
                workerStore.setWorkers(response.data.elements);
                total.value = response.data.total;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function findAll() {
            handleSearch(searchParams.value)
        }
        
        watch(() => filter.value, () => {
            searchParams.page = 1;
            findAll();
        }, {deep: true, immediate: true});
        
        watch(searchParams, (newParams) => {
            handleSearch(newParams);
        }, {deep: true});
        
        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                if (key === 'phase') {
                    filter.value[key] = "ACTIVE";
                } else {
                    filter.value[key] = null;
                }
            });
            idControlProgram.value = null;
            idIssue.value = null;
        }
        
        function view(item) {
            if (!props.intranet)
                $router.push({name: `${rootPath.value}.view`, params: {id: item.id}});
        }
        
        function setWorkerShowImage(show) {
            if (securityStore.userContext.workerShowImage !== show) {
                securityStore.setWorkerShowImage(show);
                if (show) {
                    headers.value.splice(1, 0, imageHeader);
                } else {
                    headers.value.splice(1, 1);
                }
                window.localStorage.setItem("userContext", JSON.stringify(securityStore.userContext));
            }
        }
        
        const loadingExportExcel = ref(false);
        
        function exportExcel() {
            loadingExportExcel.value = true;
            filter.value.sortBy = searchParams.value.sortBy;
            filter.value.descending = searchParams.value.descending;
            axios.get(`/workers/exportExcel`, {
                responseType: 'blob',
                params: filter.value,
            }).then(response => {
                // Create a new Blob object using the response data of the file
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'employés.xlsx'); // Set the file name for download
                document.body.appendChild(fileLink);
                
                fileLink.click(); // Programmatically trigger the download
                
                // Clean up by revoking the Object URL and removing the link element
                window.URL.revokeObjectURL(fileURL);
                fileLink.remove();
            }).finally(() => {
                loadingExportExcel.value = false;
            });
        }
        
        
        return {
            workerStore,
            securityStore,
            headers,
            loading,
            total,
            filter,
            loadingExportExcel,
            actions,
            searchParams,
            rootPath,
            formatedDate,
            setWorkerShowImage,
            exportExcel,
            clearFilter,
            findAll,
            getBack,
            view,
        };
    },
}
</script>

<template>
    <div>
        <w-app
            :title="intranet ? $t('module.intranet_worker') : $t('module.worker')"
            :total="total"
            :show-filter="!intranet"
            :filter="filter"
            @clearFilter="clearFilter"
        >
            <template v-slot:filter>
                <AdvancedWorkerFilter v-model="filter"/>
            </template>
            
            <template v-slot:leftToolbar>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>mdi-view-grid</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item @click="setWorkerShowImage(false)">
                            <v-list-item-icon>
                                <v-icon>mdi-view-list</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('common.list') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="setWorkerShowImage(true)">
                            <v-list-item-icon>
                                <v-icon>mdi-image</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('common.image') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <v-menu offset-y left v-if="!intranet">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="blue darken-2"
                            depressed
                            small
                            class="ml-2 white--text"
                            v-bind="attrs"
                            v-on="on"
                        >
                            {{ $t("common.more_action") }}
                            <v-icon right>mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item
                            v-if="securityStore.authorities['UPDATE_WORKER']"
                            @click="$router.push({name: 'workers.set_data_access'})"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-server-security</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>
                                {{ $t('worker.set_data_access') }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-divider/>
                        <v-list-item
                            v-if="securityStore.authorities['UPDATE_PAY_SLIP']"
                            @click="$router.push({name: 'workers.add_pay_sections'})"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-bookshelf</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title> {{ $t('common.add_pay_sections') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider/>
                        <v-list-item
                            v-if="securityStore.authorities['UPDATE_PAY_SLIP']"
                            @click="$router.push({name: 'workers.delete_pay_sections'})"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title> {{ $t('common.delete_pay_sections') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <w-btn-export
                    v-if="!intranet"
                    :loading="loadingExportExcel"
                    @press="exportExcel"
                />
                <w-btn-add
                    :show="securityStore.authorities['SAVE_WORKER'] && !intranet"
                    @press="$router.push({name: 'workers.add'})"
                />
            </template>
            
            <template v-slot:content>
                <v-container fluid v-if="intranet">
                    <v-row dense>
                        <v-col cols="12" md="2">
                            <w-text-field
                                v-model="filter.lastName"
                                :label="$t('common.lastname')"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <w-text-field
                                v-model="filter.firstName"
                                :label="$t('common.firstname')"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <str-occupation-autocomplete
                                v-model="filter.occupationId"
                                :label="$t('module.occupation')"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <organizational-chart-select
                                v-model="filter.organizationalchartIds"
                                :label="$t('module.organizational_chart')"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <w-data-select-autocomplete
                                v-model="filter.workplaceId"
                                type="WORKER_WORKPLACE"
                                show-default-label
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <w-data-select-autocomplete
                                v-model="filter.companyId"
                                type="WORKER_COMPANY"
                                show-default-label
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <w-server-data-table
                    v-model="searchParams"
                    :actions="intranet ? null : actions"
                    :headers="headers"
                    :items="workerStore.workers"
                    :loading="loading"
                    :total="total"
                    :hide-colors="intranet"
                    :root-path="rootPath"
                    module="WORKER"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.photo`]="{ item }">
                        <WorkerImage
                            :worker-id="item.id"
                            disable-card
                            readonly
                        />
                    </template>
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip
                            :text="item.code"
                            :icon="item.head ? 'mdi-account-supervisor-circle' : null"
                            icon-color="teal"
                        />
                    </template>
                    <template v-slot:[`item.lastName`]="{ item }">
                        <w-inline-text bold :text="item.lastName"/>
                    </template>
                    <template v-slot:[`item.firstName`]="{ item }">
                        <w-inline-text bold :text="item.firstName"/>
                    </template>
                    <template v-slot:[`item.occupationName`]="{ item }">
                        <w-inline-text :text="item.occupationName"/>
                    </template>
                    <template v-slot:[`item.organizationalChartName`]="{ item }">
                        <w-inline-text :text="item.organizationalChartName"/>
                    </template>
                    <template v-slot:[`item.realEnterDate`]="{ item }">
                        <w-inline-text :text="formatedDate(item.realEnterDate)"/>
                    </template>
                    <template v-slot:[`item.occupationCategoryClasseName`]="{ item }">
                        <w-inline-text :text="item.occupationCategoryFullName"/>
                    </template>
                    <template v-slot:[`item.stateName`]="{ item }">
                        <w-chip color="teal" :text="item.stateName"/>
                    </template>
                    
                    <template v-slot:[`item.phase`]="{ item }">
                        <w-inline-text :text="$t(`worker.PHASE_${item.phase}`)"/>
                    </template>
                    <template v-slot:[`item.birthDay`]="{ item }">
                        <w-inline-text :text="formatedDate(item.birthDay)"/>
                    </template>
                    <template v-slot:[`item.birthPlace`]="{ item }">
                        <w-inline-text :text="item.birthPlace"/>
                    </template>
                    <template v-slot:[`item.sex`]="{ item }">
                        <w-inline-text :text="$t(`worker.sex.${item.sex}`)"/>
                    </template>
                    <template v-slot:[`item.familySituationName`]="{ item }">
                        <w-inline-text :text="item.familySituationName"/>
                    </template>
                    <template v-slot:[`item.weddingDate`]="{ item }">
                        <w-inline-text :text="formatedDate(item.weddingDate)"/>
                    </template>
                    <template v-slot:[`item.address`]="{ item }">
                        <w-inline-text :text="item.address"/>
                    </template>
                    <template v-slot:[`item.personalPhone`]="{ item }">
                        <w-inline-text :text="item.personalPhone"/>
                    </template>
                    <template v-slot:[`item.professionalPhone`]="{ item }">
                        <w-inline-text :text="item.professionalPhone"/>
                    </template>
                    <template v-slot:[`item.email`]="{ item }">
                        <w-inline-text :text="item.email"/>
                    </template>
                    <template v-slot:[`item.occupationSocioProfessionalName`]="{ item }">
                        <w-inline-text :text="item.occupationSocioProfessionalName"/>
                    </template>
                    <template v-slot:[`item.responsibleName`]="{ item }">
                        <w-inline-text :text="item.responsibleName"/>
                    </template>
                    <template v-slot:[`item.companyName`]="{ item }">
                        <w-inline-text :text="item.companyName"/>
                    </template>
                    <template v-slot:[`item.workplaceName`]="{ item }">
                        <w-inline-text :text="item.workplaceName"/>
                    </template>
                    <template v-slot:[`item.exitDate`]="{ item }">
                        <w-inline-text :text="formatedDate(item.exitDate)"/>
                    </template>
                    <template v-slot:[`item.leavingCauseName`]="{ item }">
                        <w-inline-text :text="item.leavingCauseName"/>
                    </template>
                    <template v-slot:[`item.nss`]="{ item }">
                        <w-inline-text :text="item.nss"/>
                    </template>
                    <template v-slot:[`item.numMutuelle`]="{ item }">
                        <w-inline-text :text="item.numMutuelle"/>
                    </template>
                    <template v-slot:[`item.numCompte`]="{ item }">
                        <w-inline-text :text="item.numCompte"/>
                    </template>
                    <template v-slot:[`item.numCcp`]="{ item }">
                        <w-inline-text :text="item.numCcp"/>
                    </template>
                    <template v-slot:[`item.prenomPere`]="{ item }">
                        <w-inline-text :text="item.prenomPere"/>
                    </template>
                    <template v-slot:[`item.dateNaissancePere`]="{ item }">
                        <w-inline-text :text="formatedDate(item.dateNaissancePere)"/>
                    </template>
                    <template v-slot:[`item.nomMere`]="{ item }">
                        <w-inline-text :text="item.nomMere"/>
                    </template>
                    <template v-slot:[`item.prenomMere`]="{ item }">
                        <w-inline-text :text="item.prenomMere"/>
                    </template>
                    <template v-slot:[`item.dateNaissanceMere`]="{ item }">
                        <w-inline-text :text="formatedDate(item.dateNaissanceMere)"/>
                    </template>
                    <template v-slot:[`item.cnasAgencyName`]="{ item }">
                        <w-inline-text :text="item.cnasAgencyName"/>
                    </template>
                </w-server-data-table>
            </template>
        </w-app>
        
        <router-view/>
    </div>
</template>